import React from "react";
import { Link } from "react-router-dom";
import { routes } from "consts";
import { PageMain } from "components/molecules";
import { HeaderWithBreadcrumbs } from "components/molecules/HeaderWithBreadcrumbs/HeaderWithBreadbrumbs";
import { PaziaBox, PaziaLoader } from "components/atoms";
import { useViolatedBundles } from "api/payment-discounts";

export const ViolatedBundlesPage = (): JSX.Element => {
  const { isLoading, data } = useViolatedBundles();

  return (
    <PageMain>
      <HeaderWithBreadcrumbs
        breadcrumbs={[
          { title: "Kody rabatowe", path: routes.DISCOUNTS },
          { title: "Naruszone rabaty" },
        ]}
        headerText="Naruszone rabaty"
      />

      <PaziaBox>
        <p className="text-sm text-slate-600 dark:text-slate-400 mb-6">
          Lista użytkowników, którzy skorzystali z rabatu pakietowego, ale
          obecnie nie spełniają już wymagań (np. zrezygnowali z któregoś
          kursu). Sprawdź czy nie należy doliczyć dodatkowej transzy.
        </p>

        {isLoading && <PaziaLoader position="center" />}

        {!isLoading && data && data.length === 0 && (
          <div className="text-slate-500 dark:text-slate-400">
            Wszystkie bundle są w porządku.
          </div>
        )}

        {!isLoading && data && data.length > 0 && (
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left border-b border-slate-200 dark:border-slate-700">
                <th className="py-2 pr-4 font-semibold text-slate-700 dark:text-slate-300">
                  Użytkownik
                </th>
                <th className="py-2 pr-4 font-semibold text-slate-700 dark:text-slate-300">
                  Kod rabatu
                </th>
                <th className="py-2 pr-4 font-semibold text-slate-700 dark:text-slate-300">
                  Opis
                </th>
                <th className="py-2 pr-4 font-semibold text-slate-700 dark:text-slate-300">
                  Powód naruszenia
                </th>
                <th className="py-2 font-semibold text-slate-700 dark:text-slate-300">
                  Ostatnia zmiana
                </th>
              </tr>
            </thead>
            <tbody>
              {data.map((v) => (
                <tr
                  key={`${v.userId}-${v.discountId}`}
                  className="border-b border-slate-100 dark:border-slate-800"
                >
                  <td className="py-2 pr-4">
                    <Link
                      to={routes.STUDENT(v.userId)}
                      className="font-medium text-primary-600 hover:underline dark:text-primary-400"
                    >
                      {v.userFullName}
                    </Link>
                    <div className="text-xs text-slate-500 dark:text-slate-400">
                      {v.userEmail}
                    </div>
                  </td>
                  <td className="py-2 pr-4 font-mono text-slate-700 dark:text-slate-200">
                    {v.discountCode}
                  </td>
                  <td className="py-2 pr-4 text-slate-600 dark:text-slate-400">
                    {v.discountDescription}
                  </td>
                  <td className="py-2 pr-4 text-orange-600 dark:text-orange-400">
                    {v.violationReason}
                  </td>
                  <td className="py-2 text-slate-500 dark:text-slate-400">
                    {new Date(v.lastChangedAt).toLocaleDateString("pl-PL")}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </PaziaBox>
    </PageMain>
  );
};
